<div *ngIf="potentialValues">
  <input
    *ngIf="!potentialValues.length || potentialValues[0].value === 'FREEFORM'"
    type="text"
    [ngModel]="currentValue?.value"
    (ngModelChange)="onTextModelChange($event)"
    #input
    style="width: 100%"
  />

  <select
    *ngIf="potentialValues.length && potentialValues[0].value !== 'FREEFORM'"
    [ngModel]="currentValue"
    (ngModelChange)="onSelectModelChange($event)"
    data-test-selector="characteristic-select"
  >
    <option selected [ngValue]="" *ngIf="currentValue === undefined">
      Choose a Value
    </option>
    <option *ngFor="let option of potentialValues" [ngValue]="option">
      {{ option.displayValue }}
    </option>
  </select>
</div>
